var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCnhFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 39.31 27.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#b7d9cb;stroke:#334a52;stroke-miterlimit:10;stroke-width:2px}.cls-2{fill:#334a52}.cls-3{fill:#cef0e0}"))), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    style: {
      display: "inline"
    },
    transform: "matrix(.36447 0 0 .36447 -3.292 -4.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m35.642 63.68-1.067 2.628c-.086 6.095 7.599 6.99 7.697-.022l-.911-2.439z",
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#faa980",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse10",
    cx: 38.604,
    cy: 57.295,
    rx: 5.831,
    ry: 7.412,
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#febb87",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M36.318 47.214c-2.242.379-3.521 1.77-4.078 4.412-.425 2.016-.425 2.981 0 2.981.269 0 .292.2.202.985-.158 1.075.044 2.6.336 2.6.09 0 .245-.784.313-1.749.066-1.163.268-2.083.584-2.688.537-1.075.537-1.051 1.208-.605.628.402 1.389.45 4.413.223 3.049-.223 3.564 0 4.235 1.793.246.672.538 1.635.604 2.129.226 1.411.539 1.052.539-.65 0-.941.136-1.792.336-2.171.649-1.234-.068-4.102-1.277-5.132-.537-.472-.627-.628-.403-.897.223-.269.068-.382-.941-.65-1.187-.358-4.032-.807-4.659-.785-.18.024-.831.114-1.412.204z",
    style: {
      vectorEffect: "non-scaling-stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon18",
    d: "m37.259 76.012-2.937-9.773 4.36 1.111 3.909-1.178-2.597 9.84z",
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#f8eff8",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M34.28 66.212c-.204.336-1.704.985-5.288 2.331-1.66.603-3.228 1.255-3.496 1.411-.671.426-1.143 1.544-1.435 3.361-.133.85-.291 1.837-.335 2.173l-.09.582h14.989c8.267 0 15.011-.067 15.011-.135 0-.827-.717-4.211-1.029-4.862-.495-1.075-.741-1.209-4.461-2.576-1.724-.649-3.628-1.412-4.211-1.724-.605-.293-1.121-.515-1.165-.471-.046.045-.673 2.128-1.434 4.638-.741 2.508-1.412 4.613-1.459 4.683-.131.11-.288-.942-.467-2.982-.09-.873-.226-1.969-.335-2.463-.16-.696-.114-.965.133-1.255.292-.313.292-.447.044-.851-.158-.27-.447-.471-.627-.471-.178 0-.471.201-.626.471-.247.404-.247.538.021.83.267.289.291.603.158 1.388-.114.56-.269 1.949-.359 3.092-.089 1.141-.225 2.106-.315 2.171-.09.047-.627-1.5-1.21-3.426-1.68-5.647-1.858-6.162-2.014-5.915z",
    style: {
      vectorEffect: "non-scaling-stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon26",
    d: "m37.405 76.066.835-6.365-.022-.409-.525-.794.638-.892h.614l.616.934-.509.776-.015.4.925 5.752.062.605z",
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#da172a",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyline30",
    d: "m35.414 76.073 1.226-.779 1.143-2.845-1.252-.158 1.299-2.232-3.766-4.002-1.998-.001",
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#797979",
      stroke: "#000"
    },
    transform: "rotate(180 34.948 71.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyline32",
    d: "m42.362 65.942 1.162.684 1.139 2.916-1.252.273 1.684 1.982-3.484 4.271-1.918.006",
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#797979",
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon38",
    d: "m40.518 69.428-1.525-1.935-.698-.001-1.672 2.026-2.254-3.325.866-1.821 3.027 2.878h.759l2.637-2.901.842 1.914z",
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#fff",
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect8-7",
    d: "M3.56 1.041a2.535 2.535 0 0 0-2.54 2.54v20.47a2.536 2.536 0 0 0 2.54 2.54h32.231a2.535 2.535 0 0 0 2.54-2.54V3.58a2.533 2.533 0 0 0-2.54-2.54zM7.74 12.5h6.06c1.031 0 1.86.829 1.86 1.86v7.09c0 1.03-.829 1.86-1.86 1.86H7.74c-1.03 0-1.86-.83-1.86-1.86v-7.09c0-1.031.83-1.86 1.86-1.86z",
    className: "cls-1",
    style: {
      display: "inline",
      vectorEffect: "non-scaling-stroke",
      fill: "#b7d9cb",
      stroke: "#334a52",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      InkscapeStroke: "hairline"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8",
    width: 37.31,
    height: 25.55,
    x: 1,
    y: 1,
    className: "cls-1",
    rx: 2.54,
    style: {
      display: "inline",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect10",
    d: "M1 1h37.31v5.91H1z",
    className: "cls-2",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect12",
    d: "M17.85 20.74h5.92v2.57h-5.92z",
    className: "cls-2",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect14",
    d: "M25.32 20.74h8.49v2.57h-8.49z",
    className: "cls-2",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect16",
    d: "M17.85 12.5h15.96v2.03H17.85z",
    className: "cls-3",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect18",
    d: "M17.85 16.61h15.96v2.06H17.85z",
    className: "cls-3",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect22",
    d: "M5.88 8.69h27.93v2.03H5.88z",
    className: "cls-3",
    style: {
      display: "inline"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnhFront);
export default __webpack_public_path__ + "static/media/cnh_front.348b8c2b68bcbe6b8e9e29beffb22e97.svg";
export { ForwardRef as ReactComponent };